import { render } from "./ProxiesManagement.vue?vue&type=template&id=7261d405&scoped=true"
import script from "./ProxiesManagement.vue?vue&type=script&lang=js"
export * from "./ProxiesManagement.vue?vue&type=script&lang=js"

import "./ProxiesManagement.vue?vue&type=style&index=0&id=7261d405&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7261d405"]])

export default __exports__